import React from 'react';
import { useLocation, useParams, Link, Redirect } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import XPDF from 'src/components/pdf/XPDF';
import { Content } from 'src/components/light/Content';
import { SectionBlock } from 'src/components/light/SectionBlock';
import { InvoiceDocument } from '../fbl-delivery/detail';

export function GeneralDeliveryInvoiceDetailScreen() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const location = useLocation<{ invoice: any }>();
  const { invoiceNo } = useParams<{ invoiceNo: string }>();
  const [isFontLoaded, setIsFontLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsFontLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  let invoice = location.state?.invoice;

  if (!invoice) {
    const saved = localStorage.getItem(`general_preview_invoice_${invoiceNo}`);
    if (saved) {
      try {
        invoice = JSON.parse(saved);
      } catch (e) {
        console.error('Failed to parse invoice from local storage', e);
      }
    }
  }

  if (!invoice) {
    return <Redirect to="/invoices/general-delivery" />;
  }

  return (
    <Content>
      <SectionBlock title={`Invoice Preview: ${invoice.invoice_no}`}>
        <div className="mb-3">
          <Link className="btn btn-secondary btn-sm" to="/invoices/general-delivery">
            &larr; Back to List
          </Link>
        </div>
        <div>
          <div className="mb-3 text-right">
            <PDFDownloadLink
              className="btn btn-primary"
              document={<InvoiceDocument invoice={invoice} />}
              fileName={`GeneralDelivery_Invoice_${invoice.invoice_no}.pdf`}
            >
              {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
            </PDFDownloadLink>
          </div>

          <div style={{ height: '70vh', width: '100%', border: '1px solid #ccc' }}>
            {isFontLoaded ? (
              <XPDF.Preview>
                <InvoiceDocument invoice={invoice} />
              </XPDF.Preview>
            ) : (
              <div style={{ padding: 20, textAlign: 'center' }}>Loading preview...</div>
            )}
          </div>
        </div>
      </SectionBlock>
    </Content>
  );
}
